<script>

    import { createEventDispatcher } from 'svelte';
    import { UID } from '@repo/config/Utils';
    /**
     * @typedef {Object} Props
     * @property {any} action
     * @property {any} label
     * @property {boolean} [checked]
     * @property {boolean} [noAriaRole]
     * @property {any} [role]
     */
    let {
        action,
        label,
        checked = $bindable(false),
        noAriaRole = false,
        role = null
    } = $props();

    const id = 'cb_lb_' + UID();

    const dispatch = createEventDispatcher();

    function handleMenuItemClick(e) {
        e.stopImmediatePropagation();
        checked = !checked;
        dispatch('click', {action, label});
    }

    function handleKeyDown(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopImmediatePropagation();
            handleMenuItemClick(e);
        }
    }
</script>

<!-- svelte-ignore a11y_no_noninteractive_tabindex -->
<li class="floating-menu-row  interactive {checked ? 'selected' : ''}"
    onclick={handleMenuItemClick}
    onkeydown={handleKeyDown}
    role={noAriaRole ? null : (role ?? 'menuitemradio')} 
    aria-checked={checked} 
    aria-label={label}  
    tabindex="0"
    id={id}
    >
    <i class="material-icons" aria-hidden="true">{checked ? 'radio_button_checked' : 'radio_button_unchecked'}</i>
    <span>{label}</span>
</li>

<style>
    .floating-menu-row{
        display:flex;
        flex-direction:row;
        align-items:center;
        justify-content:flex-start;
        flex-shrink:0;
        max-width:20rem;
        color:#eee;
    }

    .floating-menu-row:focus-visible{
        background-color:rgb(170, 170, 170);
        outline: 2px solid black;   
        z-index: 1;
        color: #000;
    }

    .floating-menu-row:hover{
        background-color:rgba(0,0,0,0.3);
    }      

    .floating-menu-row i{
        margin:0.75rem;
        color:inherit;
        
    }

    .floating-menu-row span{
        margin:0.75rem 1.5rem 0.75rem 0;
        color:inherit;
        flex-shrink:0;
        
    }

    .selected{
        color:rgb(74, 198, 255);
    }
</style>